import paper from 'paper';
import { analyzeOffsetQuality, offsetPath as createOffsetPath, offsetStroke as createOffsetStroke } from './offset_core';
function assertFiniteNumber(value, name) {
    if (!Number.isFinite(value)) {
        throw new TypeError("".concat(name, " must be a finite number"));
    }
}
function resolveOptions(options) {
    var _a, _b, _c, _d;
    var join = (_a = options === null || options === void 0 ? void 0 : options.join) !== null && _a !== void 0 ? _a : 'miter';
    var cap = (_b = options === null || options === void 0 ? void 0 : options.cap) !== null && _b !== void 0 ? _b : 'butt';
    var limit = (_c = options === null || options === void 0 ? void 0 : options.limit) !== null && _c !== void 0 ? _c : 10;
    var algorithm = (_d = options === null || options === void 0 ? void 0 : options.algorithm) !== null && _d !== void 0 ? _d : 'auto';
    if (join !== 'miter' && join !== 'bevel' && join !== 'round') {
        throw new RangeError("Unsupported join type: ".concat(String(join)));
    }
    if (cap !== 'butt' && cap !== 'round') {
        throw new RangeError("Unsupported cap type: ".concat(String(cap)));
    }
    assertFiniteNumber(limit, 'Miter limit');
    if (limit < 0) {
        throw new RangeError('Miter limit must be greater than or equal to zero');
    }
    if (algorithm !== 'auto' && algorithm !== 'adaptive' && algorithm !== 'robust'
        && algorithm !== 'split' && algorithm !== 'legacy') {
        throw new RangeError("Unsupported offset algorithm: ".concat(String(algorithm)));
    }
    return { join: join, cap: cap, limit: limit, algorithm: algorithm };
}
function assertPath(path, requireCurve) {
    if (!(path instanceof paper.Path) && !(path instanceof paper.CompoundPath)) {
        throw new TypeError('Offset source must be a Paper.js Path or CompoundPath');
    }
    if (!requireCurve) {
        return;
    }
    var children = path instanceof paper.CompoundPath
        ? path.children
        : [path];
    var hasCurve = children.some(function (child) {
        return child.curves.some(function (curve) { return Number.isFinite(curve.length) && curve.length > 0; });
    });
    if (!hasCurve) {
        throw new RangeError('Offset source must contain at least one non-zero-length curve');
    }
}
function insertResult(source, result, options) {
    if (!options || options.insert !== false) {
        (source.parent || paper.project.activeLayer).addChild(result);
    }
}
export function offset(path, distance, options) {
    assertFiniteNumber(distance, 'Offset distance');
    assertPath(path, distance !== 0);
    var resolvedOptions = resolveOptions(options);
    if (distance === 0) {
        var result = path.clone({ insert: false });
        insertResult(path, result, options);
        return result;
    }
    var newPath = createOffsetPath(path, distance, resolvedOptions.join, resolvedOptions.limit, resolvedOptions.algorithm);
    insertResult(path, newPath, options);
    return newPath;
}
export function offsetStroke(path, distance, options) {
    assertFiniteNumber(distance, 'Offset distance');
    assertPath(path, true);
    var resolvedOptions = resolveOptions(options);
    var newPath = createOffsetStroke(path, distance, resolvedOptions.join, resolvedOptions.cap, resolvedOptions.limit, resolvedOptions.algorithm);
    insertResult(path, newPath, options);
    return newPath;
}
export function analyze(source, result, distance, options) {
    assertFiniteNumber(distance, 'Offset distance');
    assertPath(source, false);
    assertPath(result, false);
    return analyzeOffsetQuality(source, result, distance, options || {});
}
var PaperOffset = /** @class */ (function () {
    function PaperOffset() {
    }
    PaperOffset.offset = function (path, distance, options) {
        return offset(path, distance, options);
    };
    PaperOffset.offsetStroke = function (path, distance, options) {
        return offsetStroke(path, distance, options);
    };
    PaperOffset.analyze = function (source, result, distance, options) {
        return analyze(source, result, distance, options);
    };
    return PaperOffset;
}());
export { PaperOffset };
/**
 * @deprecated EXTEND existing paper module is not recommend anymore
 */
export default function ExtendPaperJs(paperNs) {
    paperNs.Path.prototype.offset = function (distance, options) {
        return offset(this, distance, options);
    };
    paperNs.Path.prototype.offsetStroke = function (distance, options) {
        return offsetStroke(this, distance, options);
    };
    paperNs.CompoundPath.prototype.offset = function (distance, options) {
        return offset(this, distance, options);
    };
    paperNs.CompoundPath.prototype.offsetStroke = function (distance, options) {
        return offsetStroke(this, distance, options);
    };
}
export { ExtendPaperJs as extendPaperJs };
//# sourceMappingURL=index.js.map